export default "__VITE_ASSET__8f020575__"